import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import * as actionTypes from "../../../store/actions/actionTypes";
import PresetModal from "../../UI/Modal/PresetModal/PresetModal";
import axios from "axios";
import apiUrl from "../../../shared/config";
import {motion} from "framer-motion";
import * as actions from "../../../store/actions";
import EditUser from "../../EditUser/EditUser";
import classes from "../UserProfile.module.css";
import "./UpdatedUserProfile.css";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import {NavLink} from "react-router-dom";
import {Edit} from "@material-ui/icons";
import {Tooltip} from "@material-ui/core";
import GroupList from "../GroupList";
import Spinner from "react-bootstrap/Spinner";
import UserPermissionList from "../UserManagement/UserPermissionList";

const [displayPatternNum, displayGameNum] = [5,5];

export default function UpdatedUserProfile({modalRef, onCloseProp, givePermissions}) {
    const [loading, setLoading] = useState(true);
    const [userProfile, setUserProfile] = useState({
        displayName: "User Not Found",
        firstName: "Unknown",
        lastName: "Unknown",
        contactEmail: "Private"
    })

    const editUserRef = useRef();

    const [groups, setGroups] = useState([]);
    const [patterns, setPatterns] = useState([]);
    const [games, setGames] = useState([]);
    const [patternCount, setPatternCount] = useState(0);
    const [gameCount, setGameCount] = useState(0)

    // redux state
    const dispatch = useDispatch();
    const show = useSelector(state => state.modal.user_modal.isOpen);
    const token = useSelector(state => state.auth.token);
    // const modalType = useSelector(state => state.modal.modal.type);
    const selectedUser = useSelector(state => state.modal.user_modal.selectedUserId);
    const editUser = useSelector(state => state.userSidebar.editUser);
    const userId = useSelector(state => state.auth.userId)
    const accountId = useSelector(state => state.auth.accountId);


    const userModal = useRef();

    const closeModal = () => {
        userModal.current.close();
        dispatch({ type: actionTypes.CLOSE_USER_MODAL });
        if (editUser) {
            dispatch({ type: actionTypes.EDIT_USER_TOGGLE})
        }
        dispatch({type: actionTypes.SELECT_USER, userId: null})
        setLoading(true);
    };

    const patternSelected = (patternId) => {
        dispatch({type: actionTypes.SELECT_PATTERN, selectedPatternId: patternId})
        if (onCloseProp) {
            onCloseProp();
        } else {
            closeModal();
        }
    }

    const clearPatternFilters = () => {
        dispatch({type: actionTypes.CLEAR_PATTERN_FILTERS});
    }

    const clearGameFilters = () => {
        dispatch({type: actionTypes.CLEAR_GAME_FILTERS});
    }

    const setPatternAuthorFilter = (gameId) => {
        dispatch({type: actionTypes.UPDATE_AUTHORS_FILTER, authors_filter: [gameId]})
    }

    const setGameAuthorFilter = (author_id) => {
        dispatch({type: actionTypes.UPDATE_GAMES_AUTHOR_FILTER, author: author_id})
    }

    const gameSelected = (gameId) => {
        dispatch({type: actionTypes.SELECT_GAME, selectedGameId: gameId});
        if (onCloseProp) {
            onCloseProp();
        } else {
            closeModal();
        }
    }

    const callUpdateHandler = () => {
        if (editUserRef.current) {
            editUserRef.current.updateHandler();
        }
    };

    const editOrSubmitUser = () => {
        if (editUserText()) {
            editUser ? callUpdateHandler() : dispatch({ type: actionTypes.EDIT_USER_TOGGLE});
        }
    }

    const editUserText = () => {
        if (selectedUser && userId && +selectedUser === +userId) {
            return editUser ? "Submit" : "Edit User Profile"
        } else {
            return null
        }
    }

    const setUserState = useCallback(() => {
        if (selectedUser) {
            try {
                axios.get(`${apiUrl}Users/getUserById?user_id=${selectedUser}`)
                    .then(response => {
                        setUserProfile({
                            displayName: response.data.display_name || "Unknown",
                            firstName: response.data.first_name || "Unknown",
                            lastName: response.data.last_name || "Unknown",
                            userId: response.data.user_id || 0,
                            contactEmail: response.data.user_contact_email || "Private", // was gonna do a check here to see if contact email should be shared but we should do that on backend instead.
                            userPermissions: response.data.user_permissions || {}
                        })
                        setGroups(response.data.groups)
                        // setPermissions(response.data.user_permissions)
                    }).then(
                    () => {
                        setLoading(false)
                    }
                )
                    .catch(() => {
                        alert("Failed to connect to server. Check your Internet Connection.");
                    });

                axios.get(`${apiUrl}PatternList/getList?quantity=${displayPatternNum}&offset=0&token=${token}&author_ids_array[]=${selectedUser}`)
                    .then(response => {
                        setPatterns(response.data.patterns_array || []);
                        setPatternCount(response.data.pattern_count || 0);
                    })
                    .catch(() => {
                        alert("Failed to connect to server. Check your Internet Connection.");
                    });

                axios.get(`${apiUrl}Games/getGamesList?quantity=${displayGameNum}&offset=0&game_name_filter=&start_date=&end_date=&author=${selectedUser}&order_by=implemented_patterns`)
                    .then(response => {
                        setGames(response.data.games_array);
                        setGameCount(response.data.game_count);
                    })
                    .catch(() => {
                        alert("Failed to connect to server. Check your Internet Connection.");
                    });
            } catch (e) {
                alert("Failed to connect to server. Check your Internet Connection.");
            }
        }
    }, [selectedUser, token]);


    useEffect(() => {
        if (userModal.current && show) {
            userModal.current.open();
        }
    }, [show]);

    useEffect(() => {
        setUserState();
    }, [selectedUser, setUserState]); // look back at react course to check why this is mad again. something about the function changing?? Should still work though.

    const patternsList = patterns.length > 0 ? <ol key={`${selectedUser} List`} className="user-profile-list">{patterns.slice(0, displayPatternNum).map((p, index)=> {
            return <li key={`${selectedUser} ListItem ${index}`}>
                <NavLink
                    to={'/PatternLibraryApp/PatternLibrary/' + p.pattern_id}
                    exact={true}
                >
                                    <span className="view-game-link" onClick={() => {
                                        //history.replace('/PatternLibraryApp/GamesReference');
                                        patternSelected(p.pattern_id);}}
                                    >
                                        {p.pattern_name + '\n'}
                                    </span>
                </NavLink></li>
        })}</ol> : null;

    const fullPatternListLink = patternCount > displayPatternNum && <>
        <hr className="user-profile-list-separator-line"/>

        <NavLink to='/PatternLibraryApp/PatternLibrary/'
                 exact={true}>
        <span className="view-game-link" onClick={() => {
            patternSelected(null);
            gameSelected(null);
            clearPatternFilters();
            setPatternAuthorFilter(+selectedUser);
        }}
        >{"View all " + patternCount + " Patterns by this Author"}</span>
        </NavLink>
    </>;


    const gameList = gameCount > 0 ? <ol className="user-profile-list"> {games.slice(0, displayGameNum).map((g, index)=> {
        return <li key={`${selectedUser} ListItem ${index}`}>
            <NavLink
                to={'/PatternLibraryApp/GamesReference/' + g.game_id}
                exact={true}
            >
                                    <span className="view-game-link" onClick={() => {
                                        //history.replace('/PatternLibraryApp/GamesReference');
                                        gameSelected(g.game_id);}}
                                    >
                                        {g.game_name + '\n'}
                                    </span>
            </NavLink></li>
    })}</ol> : null;

    const fullGameListLink = gameCount > displayGameNum && <>
        <hr className="user-profile-list-separator-line"/>
        <NavLink to='/PatternLibraryApp/GamesReference/'
                                        exact={true} >
        <span className="view-game-link" onClick={() => {
            patternSelected(null);
            gameSelected(null);
            clearGameFilters();
            setGameAuthorFilter(selectedUser);
        }}
        >{"View all " + gameCount + " Games Entered by this Author"}</span>
    </NavLink></>

    const groupsList = () => <GroupList groups={groups} userId={userId} selectedUser={selectedUser} accountId={accountId} isUserProfileView/>

    const userProfileDetails =
        loading ?
            <Spinner animation={"border"}/> :
        <motion.div initial={{scale: 0}} animate={{scale: 1}} transition={{duration: .4 }}>
            {!editUser &&
                <motion.div style={{display: "-ms-inline-flexbox"}}>
                    <div className="user-profile-box">
                        <div className="user-profile-title-box">
                            {(selectedUser && userId && selectedUser === userId) && <div style={{width: "40px"}}/>}
                            <div className='col-sm-1' />
                            <div className='col-sm-10'>
                                <h3 className="user-profile-big-title">{userProfile.displayName ? userProfile.displayName : "User Profile"}</h3>
                                {/*<h4 >{userProfile.userPermissions && userProfile.userPermissions.give_permissions ? "Super Admin" : (userProfile.userPermissions && userProfile.userPermissions.admin ? "Admin" : "")}</h4>*/}
                            </div>
                            <div className='col-sm-1'>
                            {(selectedUser && userId && selectedUser === userId) &&
                                <Tooltip title={"Edit"} placement={"top"}>
                                    <Edit
                                        onClick={editOrSubmitUser}
                                        style={{ width: '30px', // Adjust width as needed
                                            height: '30px', // Adjust height as needed
                                            color: "#003cb3",
                                            alignItems: 'center',
                                            cursor: 'pointer',
                                            marginRight: '10px',
                                            marginTop: '3px'}}
                                    />
                                </Tooltip>
                            }
                        </div>
                        </div>
                        <Container>
                            <Row className="user-profile-names">
                                <div className={classes.UserItem}>
                                    <div className={classes.UserLabel}>First Name:</div>
                                    <div className={classes.UserContent}>{userProfile.firstName}</div>
                                </div>
                                <div className={classes.UserItem}>
                                    <div className={classes.UserLabel}>Last Name:</div>
                                    <div className={classes.UserContent}>{userProfile.lastName}</div>
                                </div>
                            </Row>
                            <Row className="user-profile-email">
                                <div className={classes.UserItem}>
                                    <div className={classes.UserLabel}>Contact Email:</div>
                                    <div className={classes.UserContent}>{userProfile.contactEmail}</div>
                                </div>
                            </Row>
                        </Container>


                        {patternsList && <hr className="user-profile-line"/>}
                        {patternsList && <h3 className="user-profile-title">{patternCount > displayPatternNum ? "Popular Patterns By This Author" : "Patterns By This Author"}</h3>}
                        {patternsList}
                        {fullPatternListLink}
                        {gameList && <hr className="user-profile-line"/>}

                        {gameList && <h3 className="user-profile-title">{gameCount > displayPatternNum ? "Popular Games Entered By This Author" : "Games Entered By This Author"}</h3>}
                        <div>
                            {gameList}
                            {fullGameListLink}
                        </div>
                        {groups && groups.length > 0 && <hr className="user-profile-line"/>}

                        {groups && groups.length > 0 && <h3 className="user-profile-title">Groups</h3>}
                        <div className="user-profile-groups-list-wrapper">{groups && groups.length > 0 ? groupsList() : ''}</div>
                        {givePermissions || (userProfile.userPermissions && userProfile.userPermissions.length > 0 && userProfile.userId === parseInt(userId))
                            ? <React.Fragment>
                                <hr className="user-profile-line"/>
                                <h4 className="user-profile-title">Global Permissions</h4>
                                <UserPermissionList token={token} users={[userProfile]} givePermissions={givePermissions} accountId={accountId}></UserPermissionList>
                            </React.Fragment>
                        : ""}
                    </div>
                </motion.div>}
            {editUser && <div className="user-profile-edit-margin">
                <EditUser
                    useNew
                    ref={editUserRef}
                    account_id={accountId}
                    user_id={userId}
                    closeEditUser={closeModal}
                    submitEditUser={() => {
                        dispatch({type: actionTypes.EDIT_USER_SUBMIT, userId: userId}, actions.setUserId(userId))
                    }}
                    token={token}
                />
            </div>}
        </motion.div>


    return (
        // If there's a modalRef, then the profile should appear in an existing modal, so only the profile details are
        // returned. If there isn't a modalRef, then the user profile should appear in a new preset modal.
        modalRef
            ? <React.Fragment>{userProfileDetails}</React.Fragment>
            : <PresetModal
                ref={userModal}
                onClose={closeModal}
                buttonText={editUserText()}
                onButtonPress={editUserText() ? editOrSubmitUser : null}
            >
                <div style={{width: "600px"}}></div> {/* This feels like cheating, but it actually seems to work very well. */}
                {userProfileDetails}
            </PresetModal>
    );
}
